import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import EditMemberships from './edit-state';
import DisplayMemberships from './display-state';
import {
  updateProfileBadges as updateProfileBadgesAction,
  updateProps,
} from '../../../stores/profile/memberships/actions';
import { merge, equals, prop } from 'ramda';

const MembershipsContainer = props => {
  const {
    updateProfileBadges,
    updateProps,
    isEditable,
    membershipsReducer,
    deleteOneOrganization,
    user,
    companyProfile,
  } = props;

  const companyIdForCompanyProfile = !isEditable ? prop(0, Object.keys(companyProfile)) : undefined;
  const checkIfIsEditable = isEditable ? membershipsReducer.memberships : prop('companyBadges', companyProfile[companyIdForCompanyProfile]);
  const checkForDeletedOrg = checkIfIsEditable.filter(org => !org.delete);
  const isSupplier = equals(user.user.type, 'Supplier');

  const sortedMemberships = checkForDeletedOrg.sort((a, b) => {
    if (a.badgeId === '5ec074e495512b0156baf64f') return -1;
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });

  const sharedProps = {
    updateProps,
    isEditable,
    membershipsReducer,
    deleteOneOrganization,
    isSupplier,
    sortedMemberships,
  };

  const companyId = user.user.userID;

  return (
    <div id="membership">
      {
        !isEditable || !membershipsReducer.membershipsEditState ?
          <DisplayMemberships
            {...sharedProps}
          /> :
          <EditMemberships
            updateProfileBadge={(memberships) => updateProfileBadges(companyId, merge(memberships, { companyName: companyProfile.companyName }))}
            {...sharedProps}
          />
      }
    </div>
  );
};

MembershipsContainer.propTypes = {
  updateProps: PropTypes.func,
  isEditable: PropTypes.bool,
  saveProfileField: PropTypes.func,
  membershipsReducer: PropTypes.object,
  deleteOneOrganization: PropTypes.func,
  dispatch: PropTypes.func,
  user: PropTypes.object,
  companyProfile: PropTypes.object,
};

const mapStateToProps = ({ membershipsReducer, user, companyProfile }) => ({
  membershipsReducer: membershipsReducer.toJS(),
  user: user.toJS(),
  companyProfile: companyProfile.toJS(),
});

export default connect(mapStateToProps, {
  updateProfileBadges: updateProfileBadgesAction,
  updateProps,
})(MembershipsContainer);



// WEBPACK FOOTER //
// ./src/app/components/profile/memberships/memberships-container.jsx